import ContactDealerThankYou from '@/views/build-and-price/contact-dealer/ContactDealerThankYou.vue';
import ContactDealerForm from '@/views/build-and-price/contact-dealer/ContactDealerForm.vue';

export default [
  {
    path: '',
    redirect: { path: 'contact-dealer-form' },
  },
  {
    path: 'contact-dealer-form',
    component: ContactDealerForm,
    meta: {
      headerIcon: 'back',
      hasNext: true,
      nextRoutePath: 'contact-dealer-thank-you',
    },
  },
  {
    path: 'contact-dealer-thank-you',
    component: ContactDealerThankYou,
    meta: {
      headerIcon: 'back',
      hasNext: true,
      nextRoutePath: '../payment-summary',
    },
  },
];
